import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import Button from '@mui/material/Button';
import { L } from 'harmony-language';
import React from 'react';

interface BulkPreviewTitleBarProps {
    numberOfDrafts: number;
    generateProjections: () => void;
    handleBack: () => void;
}

export const BulkPreviewTitleBar = (props: BulkPreviewTitleBarProps) => {
    const { numberOfDrafts, generateProjections, handleBack } = props;

    return (
        <div className='bulk-title-bar justify-between'>
            <Button variant='outlined' color='primary' startIcon={<ArrowBackIcon />} onClick={handleBack}>
                {L.goBack()}
            </Button>
            <h4>{L.bulkPreviewInfo()}</h4>
            <div className='bulk-title-bar-action'>
                <Button variant='contained' color='primary' onClick={generateProjections}>{L.createBulkDrafts(numberOfDrafts.toString())}</Button>
            </div>
        </div>
    );
};
